export enum PaymentStatus {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",
  REFUNDED = "REFUNDED",
}

export enum PaymentMethod {
  ONLINE = "ONLINE",
  CASH = "CASH",
}

export enum TransactionType {
  RIDE_PAYMENT = "RIDE_PAYMENT",
  DRIVER_EARNING = "DRIVER_EARNING",
  PLATFORM_COMMISSION = "PLATFORM_COMMISSION",
  DRIVER_BONUS = "DRIVER_BONUS",
  DRIVER_PENALTY = "DRIVER_PENALTY",
  REFUND = "REFUND",
  PAYOUT = "PAYOUT",
  WALLET_TOPUP = "WALLET_TOPUP",
  ADJUSTMENT = "ADJUSTMENT",
}

export enum TransactionDirection {
  CREDIT = "CREDIT",
  DEBIT = "DEBIT",
}

export enum PayoutMethod {
  BANK_TRANSFER = "BANK_TRANSFER",
  UPI = "UPI",
  WALLET = "WALLET",
}

export enum PayoutStatus {
  REQUESTED = "REQUESTED",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

export enum PaymentFailureReason {
  PAYMENT_DECLINED = "PAYMENT_DECLINED",
  MODAL_CANCELLED = "MODAL_CANCELLED",
  TIMEOUT = "TIMEOUT",
  NETWORK_ERROR = "NETWORK_ERROR",
  USER_CANCELLED = "USER_CANCELLED",
  SIGNATURE_VERIFICATION_FAILED = "SIGNATURE_VERIFICATION_FAILED",
}
